import React from 'react'
import ContextCard from 'transfix-ui/components/ContextCard'
import FormattedPhoneNumber from 'transfix-ui/components/FormattedPhoneNumber'
import { Box, Typography } from 'transfix-ui/core'
import { IMatchRecipients } from 'apps/booking/types'
import LaneAlertAdditionalSubscriber from 'apps/marketplace/components/LaneAlertAdditionalSubscriber'

interface ILaneAlertRecipientsProps {
  carrierId: string
  recipients: IMatchRecipients[]
}

const LaneAlertRecipients = React.memo<ILaneAlertRecipientsProps>(({ carrierId, recipients }) => {
  const [recipient] = recipients
  const { firstName, id, lastName, phone, phoneExt } = recipient
  return (
    <div>
      <div>
        <a href={`/users/${id}`} target='_blank' rel='noreferrer'>
          {firstName} {lastName}
        </a>
        {phone && <FormattedPhoneNumber phoneNumber={phone} phoneExtension={phoneExt} />}
      </div>
      {recipients.length > 1 && (
        <ContextCard triggerText={`and ${recipients.length - 1} more`}>
          <Box>
            <Typography variant='h3'>Recipients</Typography>
            {recipients.map(recipient => {
              const { email, firstName, id, lastName, phone, phoneExt } = recipient
              return (
                <LaneAlertAdditionalSubscriber
                  key={`${carrierId}-${id}`}
                  userId={id}
                  firstName={firstName}
                  lastName={lastName}
                  phoneNumber={phone}
                  phoneNumberExt={phoneExt}
                  email={email}
                />
              )
            })}
          </Box>
        </ContextCard>
      )}
    </div>
  )
})
export default LaneAlertRecipients
